<template >
    <div>
        <el-button  size="mini" plain :type="menu.css==''?'primary':menu.css" @click="handleclick(menu.linkurl, index, row)" v-for="menu in menus" :key="menu.id">
            {{menu.name}}
        </el-button>
    </div>
</template>

<script>
export default {
    props: {
        menu_id: {
            type: Number,
            default() {
                return 0
            }
        },
        row: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: Number,
            default(){
                return 0
            }
        },
        menus: {
            type: Array,
            default(){
                return []
            }
        }
    },
    methods: {
        handleclick(func, index, row){
            this.$emit('on_btnclk',{func: func, index: index, row: row});
        },
    }
}
</script>